package com.zaurh.mapquizwebsite.data.model

import kotlinx.serialization.Serializable

@Serializable
data class ErrorDTO(
    val code: Int? = null,
    val message: String? = null
)